<header class="modal__header">
  <h2 id="modalLabel">{{ content.text?.title }}</h2>
  <button
    class="button modal__button--close"
    type="button"
    (click)="closeModal(true)"
    [attr.aria-label]="'general.label.close' | translate"
  >
    <i class="icon icon-ui-close--sm"></i>
  </button>
</header>
<div class="modal__content">
  <div class="modal__text" [internalInnerHtml]="content.text?.body" [userEventSource]="userEventSource"></div>
</div>
<div [ngClass]="content.hideCancelButton ? 'modal__footer' : 'modal__footer--full-width-ends'">
  @if (content.hideCancelButton !== true) {
    <button type="button" class="button button--secondary" (click)="cancel($event)">
      <span>{{ content.cancelText }}</span>
    </button>
  }
  <button
    type="button"
    class="button"
    [ngClass]="content.hideCancelButton ? 'button--primary' : 'button--cta'"
    [airButtonLoading]="isLoading"
    (click)="confirmAction($event)"
  >
    <span>{{ content.confirmText }}</span>
  </button>
</div>
